<template>
    <div id="ContainerPatientChartReview">
        <ChartReviewBase v-bind:Origin="'Patient'" />
    </div>
</template>

<script>
import ChartReviewBase from "@/components/pages/chartreview/ChartReview";
import DBFunctions from '@/common/DBFunctions.js'
import { EventBus } from '@/event-bus.js';
import Permission from '@/common/Permission'

export default {
    /*beforeRouteEnter(to, from, next) {
        next(async vm => {
            const iPI = await vm.CanViewAllowed();
            if(iPI) next()
            else next('/accessdenied');
        }) 
  },*/
  name: 'PatientChartReview',
   mixins: [ChartReviewBase,DBFunctions,Permission],
   data(){
    return {
        //permission:[],
        //Menu : this.$store.state.leftMenu,
    }
   },

   methods:{
    /*CanViewAllowed(){
      return this.permission[0].roleCanView;
    },*/
   },

   created(){
    //this.getPermissionLeftMenu(this.Menu,this.$route.path,this.permission);    
    this.InitializePermissions('ListView');
    EventBus.$on("ShowWeel", function (isShow) { 
        isShow ? this.$emit('load', true) : this.$emit('load', false);     
     }.bind(this));
    },
};
</script>